import React from "react";
import { FieldRow } from "../FieldRow/FieldRow";
import tableStyles from "../../PreviewImportModalTable.module.css";
import { stringifyValue } from "../../PreviewImportModal.utils";
import styles from "./SimpleSectionTable.module.css";
import type { SimpleSectionTableProps } from "./SimpleSectionTable.types";
import { getSimpleFieldRowKey } from "./SimpleSectionTable.utils";

export const SimpleSectionTable: React.FC<SimpleSectionTableProps> = ({ rows, onValueChange }) => (
  <table className={`${styles.previewTable} ${tableStyles.table}`}>
    <colgroup>
      <col className={tableStyles.descriptionCell} />
      <col className={tableStyles.valueCell} />
      <col className={tableStyles.arrowCell} />
      <col className={tableStyles.descriptionCell} />
      <col className={tableStyles.valueCell} />
    </colgroup>
    <thead>
      <tr className={tableStyles.groupHeader}>
        <th colSpan={5}>
          <div className={tableStyles.groupHeaderLabels}>
            <span>Origin</span>
            <span>Destination</span>
          </div>
        </th>
      </tr>
      <tr className={tableStyles.columnHeader}>
        <th>Description</th>
        <th>Value</th>
        <th className={tableStyles.arrowCell} aria-hidden="true">
          <span className={tableStyles.arrowText}>&rarr;</span>
        </th>
        <th>Description</th>
        <th>Value</th>
      </tr>
    </thead>
    <tbody>
      {rows.map(({ row, rowIndex }) => (
        <FieldRow
          key={getSimpleFieldRowKey(row, rowIndex)}
          row={row}
          value={stringifyValue(row.ChildValue)}
          onValueChange={(value) => onValueChange(rowIndex, value)}
        />
      ))}
    </tbody>
  </table>
);
